export var setTransformationType = function (query, steps) {
    if (steps)
        return 'funnel';
    if (query) {
        var transformation = 'singular';
        var analysisType = query.analysis_type, groupBy = query.group_by, interval = query.interval;
        if (groupBy)
            transformation = 'categorical';
        if (interval)
            transformation = 'chronological';
        if (groupBy && interval)
            transformation = 'categorical-chronological';
        if (analysisType === 'extraction')
            transformation = 'extraction';
        if (analysisType === 'select_unique')
            transformation = 'nominal';
        if (analysisType === 'select_unique' && groupBy)
            transformation = 'categorical-nominal';
        if (analysisType === 'select_unique' && interval)
            transformation = 'chronological-nominal';
        if (analysisType === 'select_unique' && interval && groupBy)
            transformation = 'chronological-categorical-nominal';
        return transformation;
    }
    return null;
};
